<template>
  <div>
      <mdb-row>
        <div :key="m.id" class="col-md-3 d-flex align-self-stretch"
             v-for="m in attendees" v-if="m.status=='Going' && m.attendance==attendance">
          <div class="card profile-card text-center mb-4 animated slideInDown">
            <div class="avatar mb-4">
                <avatar :avatar="m.avatar" :reputation="m.reputation"
                        :size="100" containerClass=""/>
            </div>
            <div class="badge-container">
              <mdb-badge :color="m.badgeType" v-if="m.badge">
                <mdb-icon class="mr-1" icon="clock" v-if="m.badgeType=='warning'"/>
                <mdb-icon class="mr-1" icon="users" v-if="m.badgeType=='success'"/>
                {{m.badge}}
              </mdb-badge>
            </div>
            <div class="card-body pt-0 mt-0">
              <h5 class="mb-3 font-weight-bold"><strong>{{m.name}}</strong></h5>
              <mdb-btn v-for="(b,i) in buttons" :color="b.color"
                       :key="i"
                       size="sm" rounded
                       v-if="b.val != m.attendance"
                       @click="setAttendance(m,b.val)">{{b.label}}</mdb-btn>
            </div>
          </div>
        </div>
      </mdb-row>
    <div v-if="counts==0">
      <h4>No members in this status.</h4>
    </div>
  </div>

</template>

<script>
import api from '../../services/groupsPlaceApi.js'
import Avatar from "../common/Avatar"
import MemberModal from "../group/MemberModal";
import rsvpControls from "./RsvpControls";
import {
  mdbBadge,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbCol,
  mdbContainer,
  mdbIcon,
  mdbInput,
  mdbRow,
  mdbTabs
} from 'mdbvue';

export default {
    name: 'Event-Attendance-Tab',
    components: {
      mdbBtn,
      mdbIcon,
      mdbInput,
      mdbRow,
      mdbCol,
      mdbCard,
      mdbCardBody,
      mdbCardHeader,
      mdbContainer,
      mdbBadge,
      mdbTabs,
      Avatar,
      MemberModal,
      rsvpControls
    },
    props: {
      event: {
        type: Object,
        default: []
      },
      attendees: {
        type: Array,
        default: []
      },
      attendance: {
        type: String,
        default: "Unknown"
      }

    },
    computed: {
      counts() {
        let count = 0
        for (let i=0; i<this.attendees.length; i++) {
          if (this.attendees[i].attendance == this.attendance && this.attendees[i].status == "Going") count++
        }
        return count
      }
    },
    data() {
      return {
        buttons : [{label:"Un-marked", color:"success", val:"Unknown"},
          {label: "Present", color:"success", val:"Attended"},
          {label: "Canceled", color:"warning", val: "Canceled"},
          {label: "Canceled Late", color:"warning", val: "Late Cancel"},
          {label: "No Show", color: "danger", val: "No Show"}]
      }
    },
    methods: {
      setAttendance(member, attendance) {
        this.$store.dispatch("setExecuting", true);
        api.post('/reservation/attendance/' , {id: member.reservationId,attendance: attendance}).then(
          (results) => {
            member.attendance = attendance
          },
          (error) => {
            if (error.response && error.response.data) this.$notify.error({message: error.response.data, timeOut: 10000})
            else this.$notify.error({message: "Error retrieving data.", timeOut: 10000})
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        });
      }
    }
  }
  ;
</script>
<style scoped>
  p {
    line-height: 1em;
    margin-bottom: 5px;
  }

  .profile-card {
    margin-top: 100px;
  }

  .profile-card .avatar {
    max-width: 150px;
    max-height: 150px;
    margin: -70px auto 0;
    -webkit-border-radius: 50%;
    border-radius: 50%;
    overflow: hidden;
  }

  .cascading-admin-card .admin-up {
    margin-left: 4%;
    margin-right: 4%;
    margin-top: -20px;
  }

  .cascading-admin-card .admin-up .fa {
    padding: 1.7rem;
    font-size: 2rem;
    color: #fff;
    text-align: left;
    margin-right: 1rem;
    -webkit-border-radius: 3px;
    border-radius: 3px;
  }

  .cascading-admin-card .admin-up .fa, .z-depth-2 {
    -webkit-box-shadow: 0 8px 17px 0 rgba(0, 0, 0, .2), 0 6px 20px 0 rgba(0, 0, 0, .19);
    box-shadow: 0 8px 17px 0 rgba(0, 0, 0, .2), 0 6px 20px 0 rgba(0, 0, 0, .19);
  }

  .badge-container {
    position: absolute;
    right: 0;
  }

</style>
